import React from 'react';
import { Button } from '@octane/spark';
import PropTypes from 'prop-types';
import { Container, Title, Subtitle } from './prequalified-card.styles';
import useEstimatorStore from '../ui/estimator-store/estimator-store';

const PrequalifiedCard = ({ primaryAction }) => {
   const { params, initialParams, monthlyPayment } = useEstimatorStore((state) => ({
     params: state.params,
     initialParams: state.initialParams,
   }));

   const handleCallback = (action) => {
     const isEmpty =
       !params || Object.values(params).every((val) => val === 0 || val === null);

     const selectedParams = isEmpty && initialParams ? initialParams : params;

     const lastState = {
       ...selectedParams,
       downPayment: selectedParams.cashDown,
       creditRating: selectedParams.creditRating,
       paymentRange: monthlyPayment,
     };

     if (action === "primary") {
       primaryAction.callback(lastState);
     }
   };

  return (
    <Container>
      <Title>Next, get prequalified</Title>
      <Subtitle>No Credit Impact • No Obligation</Subtitle>
      <Button
         variant="primary"
         onClick={() => handleCallback('primary')}>
         {primaryAction.label}
      </Button>
    </Container>
  );
};

PrequalifiedCard.propTypes = {
   primaryAction: PropTypes.shape({
     label: PropTypes.string.isRequired,
     callback: PropTypes.func.isRequired,
   }).isRequired,
};

export default PrequalifiedCard;
